/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface OTPChallenge
 */
export interface OTPChallenge {
    /**
     * 
     * @type {string}
     * @memberof OTPChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof OTPChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof OTPChallenge
     */
    authentication_method: FactorMethod;
}



/**
 * Check if a given object implements the OTPChallenge interface.
 */
export function instanceOfOTPChallenge(value: object): value is OTPChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}

export function OTPChallengeFromJSON(json: any): OTPChallenge {
    return OTPChallengeFromJSONTyped(json, false);
}

export function OTPChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OTPChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
    };
}

export function OTPChallengeToJSON(json: any): OTPChallenge {
    return OTPChallengeToJSONTyped(json, false);
}

export function OTPChallengeToJSONTyped(value?: OTPChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
    };
}

